import { Component, trigger, transition, style, animate, state, Input } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { STATIC_VALUE } from './../../configuration/static.value';

import { PopupService } from './../../services/pop-up.service';
import { PlantMapAdminService } from './../../../plantmap-admin/services/plant-map-admin.service';
import { FileService } from '../../services/file.service';
import { NceService } from './../../../nce/services/nce.service';
import { StorageService } from '../../../shared/services/storage.service';

@Component({
  selector: 'pop-up-view-plantmap',
  templateUrl: 'view-plantmap-popup.component.html',
  animations: [
    trigger(
      'popupAnimation',
      [
        transition(
          ':enter', [
          style({ opacity: 0 }),
          animate('300ms', style({ 'opacity': 1 }))
        ]
        ),
        transition(
          ':leave', [
          style({ 'opacity': 1 }),
          animate('300ms', style({ 'opacity': 0 }))
        ]
        )]
    )
  ],
})

export class ViewPlantmapPopupComponent {
  rb_review_feedback: string;

  @Input()
  vPlantMapData: {
    plant_request_id: string,
    plant_record_id: number,
    project_title: string,
    location: string,
    main_contractor: string,
    purchaser_company_name: string,
    restricted_area: number,
    a2_amount: number,
    trans_amount: string,
    trans_method: string,
    payment_received_date: string,
    printed_date: string,
    expriy_date: string,
    status: string,
    attachment: {},
    payment: number,
    email: string, //Kowsalya
    review_feedback: number,
    payment_verified: number,
    map_collected: number

  }

  editMode: boolean = false;
  vshow: boolean;

  constructor(
    private _popupService: PopupService,
    private _plantMapAdminService: PlantMapAdminService,
    private _fileService: FileService,
    private _nceService: NceService,
    private _storageService: StorageService
  ) {

  }

  getPopupOption() {
    return this._popupService.popUpOptions;
  }

  close() {
    this.editMode = false;
    this.getPopupOption().buttons.CANCEL.function();
  }

  getAllPlantStatus() {
    return STATIC_VALUE.ALL_PLANT_STATUS;
  }

  getChangePasswordFlag() {
    return this._popupService.getViewPlantmapFlag();
  }

  getPlantDetailsData() {
    return this.vPlantMapData;
  }

  radiochangeHandler(event: any) {
    this.rb_review_feedback = event.value;
  }
  setEditMode(pBoolean) {
    if (!pBoolean) {
      this._nceService.editPlantmap(this.getPlantDetailsData()).then(
        (resolve) => {
          this.editMode = pBoolean;
        },
        (reject) => {

        }
      );
    } else {
      this.editMode = pBoolean;
    }

  }

  downloadFile(file: string) {
    // this._fileService.getSignedDownloadRequest(file, 'PlantMap', 'restricted_area', this.getPlantDetailsData().plant_request_id);
    this._fileService.downloadPlantMapRestrictedAreaAttachmentFromDMS(file);

  }

  //Kowsalya
  accessstatus() {
    var access = JSON.parse(this._storageService.getLocalItem('access'));
    if (this.actionChecking('MANPL', access) && !(this.actionChecking('MANINU', access)) && !(this.actionChecking('MANEXU', access))) {
      return false;
    }
    else {
      return true;
    }
  }
  actionChecking(type, accesses) {
    for (var access of accesses) {
      if (access == type) {
        return true;
      }
    }
    return false;
  }
  //Kowsalya
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/view-plantmap-popup.component.ts